import { animate, style, transition, trigger } from "@angular/animations"
import { Component, ContentChildren, Input, OnInit, QueryList } from "@angular/core"
import { IconImageService } from "@shared/services/icon-image.service"

@Component({
  selector: 'flow-accordion',
  templateUrl: './flow-accordion.component.html',
  styleUrl: './flow-accordion.component.scss',
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [style({ height: 0, opacity: 0 }), animate(".2s ease-out", style({ height: "*" })), animate(".2s ease-out", style({ opacity: 1 }))]),
      transition(":leave", [style({ height: "*", opacity: 1 }), animate(".2s ease-in-out", style({ opacity: 0, height: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class FlowAccordionComponent implements OnInit {
  /* This component works same way as ag-tree-vs-node,
  but you'll need your divs in the parent components to have the selectors accordion-header and accordion-body.
  You'll also need to give the header a class so the things you insert (ex a button and a text) gets shown in a row. */

  @ContentChildren(FlowAccordionComponent, { descendants: true }) nestedBodies!: QueryList<FlowAccordionComponent>
  @Input() isOpen: boolean = false
  @Input() showButtons: boolean = true

  constructor(public iconService: IconImageService) {}

  ngOnInit(): void {}

  get bodies(): FlowAccordionComponent[] {
    return this.nestedBodies.map((n) => n)
  }

  public expandAll() {
    this.isOpen = true
    this.bodies.forEach((b) => (b.isOpen = true))
  }
  public collapseAll() {
    this.isOpen = false
    this.bodies.forEach((b) => (b.isOpen = false))
  }
}
